import React from 'react';
import {createRoot} from 'react-dom/client';
import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';
import ComponentHeader from '../../components/ComponentHeader/ComponentHeader';

import styles from "./PageOrderDomainSearchResult.scss";
import Loading from "../../common/primitives/Loading";
import whiteBox from '../../common/scss/WhiteBox.scss';
import {
	ContextDomainSearchResult,
	ContextDomainSearchResultProvider
} from "../../context/ContextDomainSearchResultProvider";
import ComponentDomainSearchAlternativesBlock
	from "../../components/ComponentDomainSearchAlternativesBlock/ComponentDomainSearchAlternativesBlock";
import {ContextServicePriceProvider} from "../../context/ContextServicePriceProvider";
import ComponentPrimaryDomainResult from "../../components/ComponentPrimaryDomainResult/ComponentPrimaryDomainResult";
import {ContextCartProvider} from "../../context/ContextCartProvider";
import {notify} from "../../common/primitives/Notification/Notification";
import HelperGoogleAnalytics from "../../common/helpers/HelperGoogleAnalytics";
import HelperGoogleAnalytics4 from "../../common/helpers/HelperGoogleAnalytics4";
import Popup from "../../common/primitives/Popup";
import ComponentCartContextMiddleware
	from "../../components/ComponentCartContextMiddleware/ComponentCartContextMiddleware";
import {_isDesktop} from "../../common/helpers/HelperFunc";
import {ContextTLDProvider} from "../../context/ContextTLDProvider";
import {__t} from '../../common/lang/text-resource';


class PageOrderDomainSearchResult extends BaseComponent {
	isCartOpen = null; //дали количката е отворена.

	constructor() {
		super(...arguments, 'PageOrderDomainSearchResult');
		SHVO.pageComponent = this;
	}

	eventConsume(actionName, actionObject) {
		// при промяна на данните в количката трябв да проверяваме дали тя е затворена или не.
		// Ако е отворена, то съдържанието на страницата се push-ва на ляво.
		if (actionName === 'ToggleCart') {
			this.isCartOpen = actionObject.isOpen;
			this.setState(this.state);
		}

		if (actionName === 'LazyLoadingComplete') {
			if (actionObject.componentName === 'ComponentCart') {
				this.isCartOpen = actionObject.componentData.isOpen && _isDesktop();
				this.setState(this.state);
			}
		}
		if (actionName === 'ContextCartUpdate') {
			if (this.isCartOpen && actionObject.countServices === 0) {
				this.isCartOpen = false;
				this.setState(this.state);
			}
		}
		if (actionName === 'ToggleCartDisabledState') {
			const continueButton = document.querySelector('#page_domain_result_continue_01');
			const continueButton2 = document.querySelector('#page_domain_result_continue_02');
			if (continueButton) {
				if (actionObject.disable) {
					continueButton.setAttribute('disabled', 'disabled');
				} else {
					continueButton.removeAttribute('disabled');
				}
			}
			if (continueButton2) {
				if (actionObject.disable) {
					continueButton2.setAttribute('disabled', 'disabled');
				} else {
					continueButton2.removeAttribute('disabled');
				}
			}
		}
	}

	continue = () => {
		let ajaxParam = new AjaxParam();
		ajaxParam.callbackError = (data) => {
			const {componentErrors} = data;
			const errorMessage = componentErrors[0];
			notify.error(this.messages[errorMessage] || errorMessage);
			this.loading = false;
			this.forceUpdate();
		};
		this.ajaxCall('ActionContinue', {}, ajaxParam);
	};

	// Повторно търсене на домейн.
	submitSearchAnother = (domainName, callBackError) => {

		/////////////////////////////////////////////////
		/////////////////////////////////////////////////
		let ajaxParam = new AjaxParam();
		ajaxParam.callbackSuccess = () => {
			/////////////////////////////////////////////////
			/////////////////////////////////////////////////
			const checkoutStep = sessionStorage.getItem('checkoutStep');
			const eventData = {
				event_category: 'InCart Actions',
				event_label: 'Product Category/Domains - Checkout/Step ' + checkoutStep + ' - Domains - ["' + domainName + '"]',
				non_interaction: true
			};
			HelperGoogleAnalytics.TrackEvent('Domain Selector - Query Domain', eventData);
			HelperGoogleAnalytics4.TrackEvent('InCart Actions', 'Domain Selector - Query Domain', 'Product Category/Domains - Checkout/Step ' + checkoutStep + ' - Domains - ["' + domainName + '"]');
			/////////////////////////////////////////////////
			/////////////////////////////////////////////////

			window.location = '/web-hosting-order-domain-results.php'
		};

		ajaxParam.callbackError = (data) => {
			const {componentErrors} = data;
			if ((typeof componentErrors === 'object') && (componentErrors.length > 0)) {
				const error = componentErrors[0];
				const domainError = this.messages[error] || error;
				notify.error(domainError);
			}

			if (typeof callBackError === 'function') {
				callBackError();
			}
		};
		ajaxParam.isLoading = false;
		this.ajaxCall('ActionSubmitSearchAnotherForm', {domainName}, ajaxParam);
	};

	render() {
		if (this.loading) {
			return (
			  <div data-layout="center row middle gutter-none" className={styles.loading}>
				  <div data-layout="col 12">
					  <Loading loadingText={__t('Зареждане...')}/>
				  </div>
			  </div>
			);
		}

		const header = this.props.data.componentData.header
		const promoCode = this.props.data.componentData.promoCode;
		const showPromoMessage = this.props.data.componentData.showPromoMessage;
		const {cart} = header.componentData;

		if (this.isCartOpen === null) {
			this.isCartOpen = cart.componentData.isOpen && _isDesktop();
		}


		return (
		  <div>
			  <ComponentHeader
				data={header}
				breadCrumbContinue={this.continue}/>

			  <div className={`${styles.container} ${this.isCartOpen ? styles.cartOpened : ''}`}>
				  <div className={styles.content}>
					  <section role="main" data-layout="text-center">
						  {/*https://jira.superhosting.bg/browse/MARKETING-83*/}
						  <h1>
							  {
								  showPromoMessage ? __t('Изберете .COM домейн за Вашия сайт!') : __t('Изберете домейн за Вашия сайт!')
							  }

						  </h1>

						  {/* Context съдържащ state-а на количката */}
						  <ContextCartProvider>
							  {/* Component който служи за връзка между ComponentCart и ContextCartProvider */}
							  <ComponentCartContextMiddleware/>
							  {/* Context съдържащ state-а на цените */}
							  <ContextServicePriceProvider>
								  <ContextTLDProvider>
									  {/* Context съдържащ state-а търсените домейни */}
									  <ContextDomainSearchResultProvider>
										  <div data-layout="row gutter-none start">
											  {/*
											 	В този consumer показваме домейна който е търсен от клиента с TLD
											 	Показва се в отделно блокче.
											 */}
											  <ContextDomainSearchResult.Consumer>
												  {
													  (data) => {
														  /** @type {Array.<DomainData>} */
														  const primaryDomainData = data.getPrimaryDomainData();

														  return (
															primaryDomainData.length > 0 &&
															<div data-layout="col 12 margin-bottom--30"
																 data-test="primary-domains-container">
																<div
																  data-layout="padding-top--20 padding-bottom--md"
																  className={`${whiteBox.container} ${whiteBox.paddingNone}`}>
																	{
																		primaryDomainData.map((domainData, index) => (
																		  <div key={domainData.id}
																			   data-layout="margin-bottom--md">

																			  {/* Блокче за търсения домейн с tld. */}
																			  <ComponentPrimaryDomainResult
																				messages={this.messages}
																				continueAction={this.continue}
																				submitSearchAnother={this.submitSearchAnother}
																				domainData={domainData}
																				hideButtons={primaryDomainData.length > 1 && index === 0}
																				hideMessage={primaryDomainData.length > 1 && index === 1}
																				searchedWithTLD={true}
																				eventRaise={this.eventRaise}/>
																		  </div>
																		))
																	}
																</div>
															</div>
														  )

													  }
												  }
											  </ContextDomainSearchResult.Consumer>

											  {/* В този consumer сменяме header-а в зависимост от това дали търсим домейн с tld или не. */}
											  <ContextDomainSearchResult.Consumer>
												  {
													  (data) => {
														  /** @type {Array.<DomainData>} */
														  const primaryDomainData = data.getPrimaryDomainData();
														  if (primaryDomainData.length > 0) {
															  const domainData = primaryDomainData[0];
															  const {
																  is_checked,
																  is_free
															  } = domainData;

															  if (is_checked) {
																  return <div className={styles.alternativesHeader}>
																	  {
																		  is_free === 1 ?
																			<h3>
																				{__t('защитeте-сайта-си-като-запазите-домейна-и-в-други9d500e')}
																			</h3> :
																			<h3>
																				{__t('Алтернативи')}
																			</h3>
																	  }
																  </div>
															  }

														  }
													  }
												  }
											  </ContextDomainSearchResult.Consumer>
											  <div data-layout="col 12" data-test="alternative-domains-container">
												  {/* Блок с алтернативни домейни.*/}
												  <ComponentDomainSearchAlternativesBlock
													promoCode={promoCode}
													messages={this.messages}
													continueAction={this.continue}
													submitSearchAnother={this.submitSearchAnother}
													eventRaise={this.eventRaise}/>

												  <div
													className={styles.ps_vat}>{__t('*Всички цени са с вкл. ДДС.')}</div>
											  </div>
										  </div>
									  </ContextDomainSearchResultProvider>
								  </ContextTLDProvider>
							  </ContextServicePriceProvider>
						  </ContextCartProvider>
					  </section>
				  </div>
				  <footer data-layout="text-center">
					  <ul className={styles.ps}>
						  {/*https://jira.superhosting.bg/browse/MARKETING-83*/}
						  {
							promoCode === '822D5M48Q' &&
							<li>{__t('-промоцията-е-валидна-за-един-com-домейн-добавен-b5c028')}</li>
						  }
						  <li>{__t('-избраните-услуги-се-активират-до-15-минути-след-405117')}</li>
						  <li>{__t('При нужда свържете се с нас денонощно на:')}</li>
						  <li>{__t('02 81 08 999 , 088 55 888 22')}</li>
					  </ul>
					  <br/>
					  <br/>
				  </footer>
			  </div>
			  <Popup data={{}} name={'bgDomainPopup'} isVisible={false} content={
				  {
					  heading: __t('Условия за регистрация на домейни в областта .BG'),
					  paragraphs: [
						  __t('за-регистрация-на-BG-бг-домейн-е-необходимо-да-пbfbbe0')
					  ]
				  }
			  }/>
			  <Popup data={{}} name={'bgDomainPopupSaved'} isVisible={false} content={
				  {
					  heading: __t('Домейнът се запазва за регистрация от вас'),
					  paragraphs: [
						  __t('домейн-%-domain_name-%-също-ще-бъде-запазен-за-ва2d1e76')
					  ]
				  }
			  }/>
			  <Popup data={{}} name={'bgDomainPopupNotAllowed'} isVisible={false} content={
				  {
					  heading: __t('Неразрешена регистрация'),
					  paragraphs: [
						  __t('името-на-домейна-трябва-да-съдържа-поне-една-отлиf9299c')
					  ]
				  }
			  }/>
			  <Popup data={{}} name={'premiumDomainPopup'} isVisible={false} content={
				  {
					  heading: __t('Регистрация на специални (premium) домейни'),
					  paragraphs: [
						  __t('-регистрацията-и-подновяването-на-специални-premif2053e')
					  ]
				  }
			  }/>
		  </div>
		)
	}
}

const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageOrderDomainSearchResult data={SHVO.pageState} isLazy={1}/>);